// @ts-nocheck

class GiftModal {
  constructor() {
    this.setupEvents();
  }

  setupEvents() {
    document.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    const closeBtn = e.target.closest('[data-gift-modal-close]');
    if (closeBtn) {
      this.closeModal(closeBtn.closest('[data-gift-modal]'));
      return;
    }

    const dialog = e.target.closest('[data-gift-modal]');
    if (dialog) {
      if (e.target === dialog) this.closeModal(dialog);
      return;
    }

    const card = e.target.closest('.pair-gift_content');
    if (card) this.openModal(card.querySelector('[data-gift-modal]'));
  }

  openModal(dialog) {
    if (dialog && !dialog.open) dialog.showModal();
  }

  closeModal(dialog) {
    if (dialog) dialog.close();
  }
}

new GiftModal();
